import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @internal
 */
export const GenericWalletIcon = (props) => {
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: props.size, height: props.size, role: "presentation", children: _jsx("path", { fill: "currentColor", d: "M15.6 4.6H1.85v-.55l12.1-.968v.968h1.65V2.4c0-1.21-.98-2.059-2.177-1.888L2.378 2.089C1.18 2.26.2 3.39.2 4.6v11a2.2 2.2 0 002.2 2.2h13.2a2.2 2.2 0 002.2-2.2V6.8a2.2 2.2 0 00-2.2-2.2zm-1.65 7.707a1.65 1.65 0 01-.63-3.176 1.65 1.65 0 11.63 3.176z" }) }));
};
//# sourceMappingURL=GenericWalletIcon.js.map